/** @jsxImportSource @emotion/react */

export const UI_VERSION = "5.4.0";

export default function Version({ customCss }) {
  return (
    <div
      css={{
        ...customCss
      }}
    >
      V {UI_VERSION}
    </div>
  );
}
